export default "__VITE_ASSET__Bc6C498T__"